import MainCatalogsEditorBase from '../MainCatalogsEditorBase';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './ProfessionsEditor.html?raw';
import SearchSelect from '../../../moreCore/UI/SearchSelect/SearchSelect';
import "../../../moreCore/UI/SearchSelect/SearchSelect";
import Edit from '../../../moreCore/UI/Edit/Edit';
import "../../../moreCore/UI/Edit/Edit";
import MultiLangEdit from '../../../moreCore/UI/MultiLangEdit/MultiLangEdit';
import "../../../moreCore/UI/MultiLangEdit/MultiLangEdit";
import CheckBox from '../../../moreCore/UI/CheckBox/CheckBox';
import "../../../moreCore/UI/CheckBox/CheckBox";
import NumberInput from '../../../moreCore/UI/NumberInput/NumberInput';
import "../../../moreCore/UI/NumberInput/NumberInput";
import { MainCatalogTypes, MainCatalogs_Classes } from "../../_loadingHelpers/MainCatalogTypes";

class ProfessionsEditor extends compose(MainCatalogsEditorBase) {

    templateString: any = template;



    as_Input_Code: MdsLax<InstanceType<typeof Edit>>;
    as_Input_Description_Multi_Lang: MdsLax<InstanceType<typeof MultiLangEdit<MainCatalogTypes.EvProfessions_LoadData>>>;
    as_Input_ProfessionType: MdsLax<InstanceType<typeof SearchSelect>>;
    as_Input_PerformerDisplayMode: MdsLax<InstanceType<typeof SearchSelect>>;
    as_Input_ProfessionGroup: MdsLax<InstanceType<typeof SearchSelect>>;
    //as_Input_TextColor: HTMLInputElement;
    //as_Input_BackgroundColor: HTMLInputElement;
    as_Input_Order: MdsLax<InstanceType<typeof NumberInput>>;

    as_Checkbox_IsConductor: MdsLax<InstanceType<typeof CheckBox>>;
    /*as_Checkbox_ShowProfession = new CheckBox();*/
    as_Checkbox_IsSoloInstrument: MdsLax<InstanceType<typeof CheckBox>>;


    formData: MainCatalogTypes.EvProfessions_SaveData = {
        ID: "",
        code: "",
        description: "",
        is_conductor: null,
        /*is_show_ev_professions: null,*/
        is_solo_instrument: null,
        order: null,
        ev_profession_type_id: "",
        performer_display_mode_id: "",
        ev_profession_groups_id: "",
        /*coloration: null,*/
        is_new_status: null,
        __multilang: {}
    };

    prepareFormData(data?: MainCatalogTypes.EvProfessions_LoadData): void {      
        let typeId: string = null;
        let displayModeId: string = null;
        let professionGroupId: string = null;

        if (data) {
            console.log(data);

            this.formData.ID = data.ID;
            
            this.as_Input_Code.setValue(data.code, true);
            //Testing purpose - Should make api call and set data with return value
            this.as_Input_Description_Multi_Lang.setValue({ entity: data, targetAttribute: "description" }, true);

            if (data.ref_ev_profession_type) {
                this.as_Input_ProfessionType.loadListValues(data.ref_ev_profession_type.ID, true);
                typeId = data.ref_ev_profession_type.ID;
            } else {
                this.as_Input_ProfessionType.loadListValues();
            }

            this.as_Input_PerformerDisplayMode.loadListValues(data.ref_performer_display_mode.ID, true);
            displayModeId = data.ref_performer_display_mode.ID;

            this.as_Input_ProfessionGroup.loadListValues(data.ref_ev_profession_groups.ID);
            professionGroupId = data.ref_ev_profession_groups.ID;


            //this.as_Input_TextColor.value = data.ref_ev_profession_groups.coloration.TextColor.Hex;
            //this.as_Input_BackgroundColor.value = data.ref_ev_profession_groups.coloration.BackColor.Hex;
            this.as_Input_Order.setValue(data.order, true);

            this.as_Checkbox_IsConductor.setValue(data.is_conductror, true);
            /*this.as_Checkbox_ShowProfession.setValue(data.is_show_ev_professions, true);*/
            this.as_Checkbox_IsSoloInstrument.setValue(data.is_solo_instrument, true);

            this.formData.is_new_status = false;

        } else {

            this.formData.ID = "";

            this.as_Input_Code.setValue("", true);
            //Tesing purpose - Should make api call and set data with return value
            this.as_Input_Description_Multi_Lang.setValue({ entity: data, targetAttribute: "description" }, true);

            this.as_Input_ProfessionType.loadListValues();
            this.as_Input_PerformerDisplayMode.loadListValues();
            this.as_Input_ProfessionGroup.loadListValues();

            //this.as_Input_TextColor.value = "#ffffff";
            //this.as_Input_BackgroundColor.value = "#000000";
            this.as_Input_Order.setValue(null, true);

            this.as_Checkbox_IsConductor.setValue(null, true);
            /*this.as_Checkbox_ShowProfession.setValue(null, true);*/
            this.as_Checkbox_IsSoloInstrument.setValue(null, true);

            this.formData.is_new_status = true;
        }

        this.serializeFormData(typeId, displayModeId, professionGroupId);
        this.originalData = JSON.stringify(this.formData);
        console.debug("ORIGINAL", this.originalData);
        this.StandbyStop();

        this.checkDirty();
    }

    serializeFormData(typeId?: string, displayModeId?: string, professionGroupId?: string): void {
        this.formData.code = this.as_Input_Code.getValue();
        //Workaround for Multilang Edit -> should I assign description_D and description_E until Backend is changed?
        var inputPath = `description_${window.currentLanguageCode}`
        //this.formData.description = this.as_Input_Description_Multi_Lang.getValue()[inputPath];
        //this.formData.__multilang["description"] = this.as_Input_Description_Multi_Lang.getValue();
        this.as_Input_Description_Multi_Lang.getValueOntoEntity(this.formData as any);

        typeId ? this.formData.ev_profession_type_id = typeId : this.formData.ev_profession_type_id = this.as_Input_ProfessionType.getValue();
        displayModeId ? this.formData.performer_display_mode_id = displayModeId : this.formData.performer_display_mode_id = this.as_Input_PerformerDisplayMode.getValue();
        professionGroupId ? this.formData.ev_profession_groups_id = professionGroupId : this.formData.ev_profession_groups_id = this.as_Input_ProfessionGroup.getValue();

        this.formData.order = this.as_Input_Order.getValue();

        this.formData.is_conductor = this.as_Checkbox_IsConductor.getValue();
        /*this.formData.is_show_ev_professions = this.as_Checkbox_ShowProfession.getValue();*/
        this.formData.is_solo_instrument = this.as_Checkbox_IsSoloInstrument.getValue();
        

        //let coloration: MainCatalogTypes.PIT_Coloration = {
        //    TextColor: null,
        //    BackColor: null
        //};
        //let textColor: MainCatalogTypes.PIT_Color = {
        //    Hex: "",
        //    Red: 0,
        //    Green: 0,
        //    Blue: 0
        //};
        //let backColor: MainCatalogTypes.PIT_Color = {
        //    Hex: "",
        //    Red: 0,
        //    Green: 0,
        //    Blue: 0
        //};
        //let textHex = this.as_Input_TextColor.value;
        //let backHex = this.as_Input_BackgroundColor.value;

        //textColor.Hex = textHex;
        //textColor.Red = parseInt(textHex.slice(1, 3), 16);
        //textColor.Green = parseInt(textHex.slice(3, 5), 16);
        //textColor.Blue = parseInt(textHex.slice(5, 7), 16);

        //backColor.Hex = backHex;
        //backColor.Red = parseInt(backHex.slice(1, 3), 16);
        //backColor.Green = parseInt(backHex.slice(3, 5), 16);
        //backColor.Blue = parseInt(backHex.slice(5, 7), 16);

        //coloration.TextColor = textColor;
        //coloration.BackColor = backColor;

        //this.formData.coloration = coloration;

        console.debug("SERIALIZED DATA", this.formData);
    }



    isValid(): boolean {

        console.log(this.formData);

        let b: boolean = true;

        if (!this.formData.code) {
            this.indicateErrorOnInput(this.as_Input_Code.inputNode, "warningBG");
            b = false;
        }
        //if (!(this.formData.description && this.formData.description.length > 0)) {
        //    this.indicateErrorOnInput(this.as_Input_Description_Multi_Lang.inputNode, "warningBG");
        //    b = false;
        //}
        if (!this.formData.ev_profession_type_id) {

            this.indicateErrorOnInput(this.as_Input_ProfessionType, "warningBG");
            b = false;
        }

        if (!this.formData.performer_display_mode_id) {
            this.indicateErrorOnInput(this.as_Input_PerformerDisplayMode, "warningBG");
            b = false;
        }

        if (!b) console.log("validation error"); 
        return b;
    }

    _onChangeProfessionsInputData(): void {
        this.serializeFormData();
        this.checkDirty();
    }



    //BASE
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.RequestManager.handleAs = "json";

        this.entityClass = MainCatalogs_Classes.Professions;
        
        this.as_Input_Code.setMaxLength(20);
        this.as_Input_Description_Multi_Lang.setMaxLength(255);
        this.as_Input_ProfessionType.setOuterPlaceholder("MainCatalogsEditor_Placeholder_ActivityStatusGroup");
    }
    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(ProfessionsEditor);
